/**
 * Bidirectional text safety (QM-NX-017 bidi spoofing, QM-D08-002 mixed text).
 * - sanitizeBidi: strips explicit embedding/override/isolate controls from untrusted text (names, messages)
 *   so "‮gpj.exe" style spoofing cannot reorder what the user sees.
 * - isolate: wraps a run of opposite-direction text (brand names inside Arabic) in FSI..PDI so it renders
 *   in its own direction without disturbing the surrounding sentence. In React prefer <bdi>.
 */
// LRE RLE PDF LRO RLO (U+202A-202E), LRI RLI FSI PDI (U+2066-2069)
const BIDI_CONTROLS = /[‪-‮⁦-⁩]/g;
export const FSI = '⁨';
export const PDI = '⁩';

export function hasBidiControls(text: string): boolean {
  BIDI_CONTROLS.lastIndex = 0;
  return BIDI_CONTROLS.test(text);
}

export function sanitizeBidi(text: string): string {
  return text.replace(BIDI_CONTROLS, '');
}

export function isolate(text: string): string {
  return `${FSI}${sanitizeBidi(text)}${PDI}`;
}

/** Wrap Latin runs (brand names, emails, URLs) inside RTL text in isolates. */
export function isolateLatinRuns(text: string): string {
  return sanitizeBidi(text).replace(/[A-Za-z0-9][A-Za-z0-9 .@:/_+-]*[A-Za-z0-9]|[A-Za-z0-9]/g, (m) => `${FSI}${m}${PDI}`);
}
